import useIsBuyer from 'hooks/useIsBuyer';
import { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { getRequest } from 'utils/api';
import {
  addConnection as addConnectionAction,
  setConnections,
} from 'features/onlyFansConnectionsSlice';

const useOnlyFansConnections = () => {
  const dispatch = useDispatch();
  const isBuyer = useIsBuyer();
  const [isLoading, setIsLoading] = useState(false);

  const connections = useSelector(state => state.onlyFansConnections.connections);

  const addConnection = connection => {
    dispatch(addConnectionAction(connection));
  };

  useEffect(() => {
    setIsLoading(true);

    getRequest({ endpoint: 'only_fans_connections' })
      .then(connections => {
        dispatch(setConnections(connections));
      })
      .catch(error => {
        console.error('Error fetching C4 accounts:', error);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, [dispatch]);

  const enabledConnections = connections.filter(connection => connection.enabled);
  const anyDisabledConnections = connections.length > enabledConnections.length;
  const onlyFansConnected = isBuyer
    ? enabledConnections.length > 0
    : enabledConnections.some(connection => connection.influencer_network_id);

  return {
    connections,
    enabledConnections,
    isLoading,
    anyDisabledConnections,
    onlyFansConnected,
    addConnection,
  };
};

export default useOnlyFansConnections;
